export const TEMPLATE_EXAMPLES = [
  {
    id: 'inv1',
    link: '/media/images/examples/inv1.png',
    altText: 'White background with blue highlights without column borders',
    isPreviewable: true,
  },
  {
    id: 'inv2',
    link: '/media/images/examples/inv2.png',
    altText: 'White background with bordered layout',
    isPreviewable: true,
  },
  {
    id: 'inv3',
    link: '/media/images/examples/inv3.png',
    altText: 'White background with alternate dark and light rows',
    isPreviewable: true,
  },
  {
    id: 'inv4',
    link: '/media/images/examples/inv4.png',
    altText: 'White background with blue accents without column borders',
    isPreviewable: true,
  },
  {
    id: 'inv5',
    link: '/media/images/examples/inv5.png',
    altText: 'White background with blue accents with table borders',
    isPreviewable: true,
  },
  {
    id: 'inv6',
    link: '/media/images/examples/inv6.png',
    altText: 'White background with black accents without column borders',
    isPreviewable: true,
  },
  {
    id: 'inv7',
    link: '/media/images/examples/inv7.png',
    altText: 'White background with rounded containers and black accent',
    isPreviewable: true,
  },
];
